exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#universalControls .feedbackBar{position:fixed;right:-28px;bottom:74px;height:0;z-index:100000000}#universalControls .feedbackBar .feedbackEmail{display:block;color:#fff;background:#c31030;padding:4px 64px;text-decoration:none;cursor:pointer;transform:rotate(-30deg)}#universalControls .feedbackBar .feedbackEmail:hover{opacity:.7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/layout/universal_controls.scss
// module id = 1344
// module chunks = 0